import { FeatureFlagState } from './types';

export const initialState: FeatureFlagState = {
  featureFlags: {},
  loading: true,
};
